import React from "react";

export default function WarningIcon() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 16 16"
			role="img"
			width="16"
			height="16"
			aria-hidden="true"
			aria-label="warning"
			className="secure-messaging-component__warning-icon"
		>
			<path
				stroke="currentColor"
				strokeLinecap="square"
				strokeWidth="1.2"
				d="M8 4.067V8.09M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0Zm-6.486 3.515a.514.514 0 1 1-1.028 0 .514.514 0 0 1 1.028 0Z"
			/>
		</svg>
	);
}
